import { mapGetters } from 'vuex';
import viewport from '~/mixins/viewport';
export default {
    mixins: [viewport],
    data() {
        return {
            isCabinetWindowOpen: false,
            userTheme: 'light-theme'
        };
    },
    components: {
        ProfileFilledIcon: () => import('@/components/svg/ProfileFilledIcon'),
        ProfileEmptyIcon: () => import('@/components/svg/ProfileEmptyIcon')
    },
    methods: {
        logout() {
            this.$store.dispatch('auth/logout');
        },
        redirectTo(path) {
            this.$router.push(this.localePath(path));
            this.setIsCabinetWindowOpen(false);
        },
        setIsCabinetWindowOpen(flag) {
            this.isCabinetWindowOpen = flag;
        },
        triggerAuthBtn() {
            if (this.isAuth) this.logout();
            else this.$store.dispatch('setShowAuth', true);
        },

        forceRepaint() {
            document.body.style.display = 'none';
            document.body.offsetHeight;
            document.body.style.display = '';
        },
        setTheme(name) {
            this.userTheme = name;

            if (name === 'light-theme') {
                document.body.classList.remove('dark-theme');
                document.body.classList.add('light-theme');
                this.$cookies.set('user-theme', 'light-theme');
                this.$store.dispatch('global/setTheme', 'light-theme');
            } else if (name === 'dark-theme') {
                document.body.classList.remove('light-theme');
                document.body.classList.add('dark-theme');
                this.$cookies.set('user-theme', 'dark-theme');
                this.$store.dispatch('global/setTheme', 'dark-theme');
            }

            this.forceRepaint();
        },
        getTheme() {
            const savedTheme = this.$cookies.get('user-theme');

            const isDarkTheme = document.body.classList.contains('dark-theme');

            if (savedTheme) {
                return savedTheme;
            } else {
                if (isDarkTheme) {
                    return 'dark-theme';
                }
                return 'light-theme';
            }
        },
        toggleTheme() {
            const activeTheme = this.getTheme(); //localStorage?.getItem('user-theme');
            if (activeTheme === 'light-theme') {
                this.setTheme('dark-theme');
            } else {
                this.setTheme('light-theme');
            }
        },
        openCartDynamic() {
            if (this.isRegistrationRequiredForOrder && !this.isAuth) {
                this.triggerAuthBtn();
                return;
            }

            if (this.isCasaCart || this.isStepByStepCart) {
                this.$router.push({ path: this.localePath('/cart') });
            } else {
                this.openCart();
            }
        }
    },

    computed: {
        ...mapGetters({
            userData: 'auth/getUserData',
            isAuth: 'auth/isAuth',

            globalSettings: 'global/globalSettings',
            isVitrina: 'global/isVitrina',
            isCasaDelTabaco: 'global/getIsCasaDelTabaco',
            getCurrentTheme: 'global/getCurrentTheme',
            isRegistrationRequiredForOrder: 'global/getIsRegistrationRequiredForOrder'
        }),
        isAuthentificationAllowed() {
            return this.globalSettings.additional_settings?.is_user_cabinet || false;
        },
        logo() {
            if (this.isUnderOrEqualViewport768) {
                if (this.getCurrentTheme === 'light-theme') {
                    return this.globalSettings?.logo?.mobileLogoLight || this?.globalSettings?.logo?.logoLight;
                } else {
                    return this.globalSettings?.logo?.mobileLogoDark || this?.globalSettings?.logo?.logoDark;
                }
            } else {
                if (this.getCurrentTheme === 'light-theme') {
                    return this.globalSettings?.logo?.logoLight;
                } else {
                    return this.globalSettings?.logo?.logoDark;
                }
            }
        },
        isCasaCart() {
            return this.globalSettings?.mainUiInterface?.cart_button_catalog_view_type === 'casadeltabaco';
        },
        isStepByStepCart() {
            return this.globalSettings?.mainUiInterface?.cart_button_catalog_view_type === 'step_by_step';
        }
    },
    mounted() {
        const initUserTheme = this.getTheme() || this.getMainTheme?.replace(/_/, '-');
        this.setTheme(initUserTheme);
    }
};
